export const { REACT_APP_API_URL: API_URL } = process.env;
